export default "__VITE_ASSET__c_2sWAQs__";